(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const ANIM_SELECTOR = '[data-anim], [data-anim-stagger]';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              entry.target.classList.add('is-visible');
            });
          });
          if (entry.target.dataset.animRepeat === undefined) {
            observer.unobserve(entry.target);
          }
        } else if (entry.target.dataset.animRepeat !== undefined) {
          entry.target.classList.remove('is-visible');
        }
      });
    },
    {
      threshold: 0,
      rootMargin: '0px 0px -50px 0px'
    }
  );

  function observeAll(root) {
    (root || document).querySelectorAll(ANIM_SELECTOR).forEach((el) => {
      // Evita di ri-osservare elementi già visibili
      if (el.classList.contains('is-visible')) return;
      observer.observe(el);
    });
  }

  // Init iniziale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeAll());
  } else {
    observeAll();
  }

  // Theme editor: ri-osserva quando una sezione viene ricaricata
  document.addEventListener('shopify:section:load', (e) => {
    observeAll(e.target);
  });

  // === MutationObserver per contenuto dinamico (cart drawer, AJAX, ecc.) ===
  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue; // solo Element nodes

        // Se il nodo aggiunto è esso stesso animabile
        if (node.matches && node.matches(ANIM_SELECTOR)) {
          observer.observe(node);
        }
        // Se contiene elementi animabili al suo interno
        if (node.querySelectorAll) {
          node.querySelectorAll(ANIM_SELECTOR).forEach((el) => {
            if (!el.classList.contains('is-visible')) {
              observer.observe(el);
            }
          });
        }
      }
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Esponi a window per markup dinamico controllato manualmente
  window.refreshAnimations = observeAll;
})();